import React from 'react';
import GenericPopup from '../../Components/GenericPopup';
import { CommonUtil } from '../../utils/CommonUtil';

interface OverlappingListingsPopupProps {
    show: boolean;
    restData: any;
    onClose: () => void;
    onConfirm: () => void;
}

const OverlappingListingsPopup: React.FC<OverlappingListingsPopupProps> = ({ show, restData, onClose, onConfirm }) => {
    if (!restData) return null;

    const onClickListing = (equipmentId: any) => {
        localStorage.setItem("ViewTab", "true");
        let siteOrigin: string = window.location.origin;
        siteOrigin = siteOrigin + "/?requestor=";
        let strPath = "equipview&equipid=" + equipmentId + "&screenType=" + CommonUtil.SCREEN_NAME;
        siteOrigin = siteOrigin + strPath;
        var newTab = document.createElement('a');
        newTab.href = siteOrigin;
        newTab.setAttribute('target', '_blank');
        newTab.click();
    };

    const onClickReservation = (item: any) => {
        localStorage.setItem("ReservationTab", "true");
        let equipId: string = item.equipmentId;
        let reservationId: string = item.reservationId;
        let reservationAssetType: string = item.assetType;
        let isGeneric: string = item.isGeneric;
        let equipType: string = item.equipmentType;
        let availId: string = item.equipmentListingId;

        let siteOrigin: string = window.location.origin;
        siteOrigin = siteOrigin + "/?requestor=reservationview&equipid=" + equipId + "&token=" + localStorage.getItem("token");
        siteOrigin = siteOrigin + "&reservationId=" + reservationId;
        siteOrigin = siteOrigin + "&assetType=" + reservationAssetType;
        siteOrigin = siteOrigin + "&equipType=" + equipType;
        siteOrigin = siteOrigin + "&generic=" + isGeneric;
        siteOrigin = siteOrigin + "&availId=" + availId;

        var newTab = document.createElement('a');
        newTab.href = siteOrigin;
        newTab.setAttribute('target', '_blank');
        newTab.click();
    };

    return (
        <GenericPopup
            header="Warning"
            mode={show ? "view" : null}
            onClose={onClose}
            size="md"
            centeredHeader={true}
        >
            <div>
                <p className="mx-0 p-1" style={{ backgroundColor: "#ffcdcc" }}>
                    <small>{restData?.message || restData?.errorMessage}</small>
                </p>
                {restData.overlappingListings?.length > 0 &&
                <>
                    <h6>Overlapping Listings</h6>
                    <table className="table table-bordered mt-2" style={{ fontSize: '12px' }}>
                        <thead>
                            <tr>
                            <th>Equipment Id</th>
                            <th>Start Date</th>
                            <th>End Date</th>
                            <th>Status</th>
                            <th>Type</th>
                        </tr>
                    </thead>
                    <tbody>
                        {restData.overlappingListings?.map((item: any, idx: number) => (
                            <tr key={idx}>
                                <td>
                                    <span
                                        style={{ color: '#007bff', textDecoration: 'underline', cursor: 'pointer' }}
                                        onClick={() => onClickListing(item.equipmentId)}
                                    >
                                        {item?.unitNumber || item.equipmentId || ""}
                                    </span>
                                </td>
                                <td>{item.startDate}</td>
                                <td>{item.endDate}</td>
                                <td>{item.listingStatus}</td>
                                <td>{item.listingType}</td>
                            </tr>
                        ))}
                    </tbody>
                </table></>}
                {restData?.overlappingReservations?.length > 0 &&
                <><h6>Overlapping Reservations</h6>
                <table className="table table-bordered mt-2" style={{ fontSize: '12px' }}>
                    <thead>
                        <tr>
                            <th>Reservation Code</th>
                            <th>Status</th>
                            <th>Start Date</th>
                            <th>End Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {restData?.overlappingReservations?.map((item: any, idx: number) => (
                            <tr key={idx}>
                                <td>
                                    <span
                                        style={{ color: '#007bff', textDecoration: 'underline', cursor: 'pointer' }}
                                        onClick={() => onClickReservation(item)}
                                    >
                                        {item?.reservationCode || ""}
                                    </span>
                                </td>
                                <td>{item.reservationStatus}</td>
                                <td>{item.startDate}</td>
                                <td>{item.endDate}</td>
                            </tr>
                        ))}
                    </tbody>
                </table></>}
                <div className="d-flex justify-content-end mt-3">
                    <button className="btn btn-secondary" style={{ marginRight: '8px' }} onClick={onClose}>Change Dates</button>
                    <button className="btn btn-primary" onClick={onConfirm}>Confirm</button>
                </div>
            </div>
        </GenericPopup>
    );
};

export default OverlappingListingsPopup;
